import { z } from 'zod';

export const InviteUserSchema = z.object({
  email: z.string().email('Valid email is required'),
  name: z.string().min(1, 'Name is required').max(200),
  role_id: z.string().uuid('Valid role is required'),
  temp_password: z.string().min(8, 'Password must be at least 8 characters'),
});

export const UpdateUserSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  email: z.string().email().optional(),
  role_id: z.string().uuid().optional(),
  temp_password: z.string().min(8).optional(),
  permission_overrides: z
    .array(
      z.object({
        permission_id: z.string().uuid(),
        granted: z.boolean(),
      }),
    )
    .optional(),
});

export const BulkUserActionSchema = z.object({
  user_ids: z.array(z.string().uuid()).min(1, 'At least one user is required'),
  action: z.enum(['assign_role', 'deactivate']),
  role_id: z.string().uuid().optional(),
});

export const ChangePasswordSchema = z.object({
  current_password: z.string().optional(),
  new_password: z.string().min(8, 'Password must be at least 8 characters'),
});

export type InviteUser = z.infer<typeof InviteUserSchema>;
export type UpdateUser = z.infer<typeof UpdateUserSchema>;
export type BulkUserAction = z.infer<typeof BulkUserActionSchema>;
export type ChangePassword = z.infer<typeof ChangePasswordSchema>;
